import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { errorHandeling } from "../errorHandeling";
import apiUrl from "../libs/baseUrl";

export function useAllRelatives() {

const token = useSelector(state => state.user.token);     

//===state start here===
const [searchResult, setSearchResult] = useState([]);
const [total, setTotal] = useState(1);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);  
const [loading,setLoading] = useState(false);
const [error,setError] = useState(null);

//===state end here===

//===Event handler start here===

const handleParamsDependOnStatus = ( status , page )=>{
  let params = {} ;

  if( status ==="ALL" ){
    params = {
      page : page
    }
  }
  else{
    params = {
      status: status,
      page : page
    }
  }

  return params;
}

const handleGetRelativesData = async( searchValue , statusOfRelData , page )=>{
 
 let url;
        
    if (searchValue && searchValue !==0 && searchValue.trim() !== "") {
     url = `${apiUrl}/relatives/search/${searchValue}`;
    }
    else{
      url = `${apiUrl}/relatives/search`;
    }


    setError(null);

    try {
      setLoading(true);
      let response;
  
        response = await axios.post( url , 
          {},
          {//config
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: handleParamsDependOnStatus(statusOfRelData , page)
        });
       
      setSearchResult(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setTotalPages(response.data.data.last_page);
      setTotal(response.data.data.total);
      setLoading(false)
      } catch (error) {
        setError(errorHandeling(error));
        console.error("error",error);
        setSearchResult([]);
        setLoading(false);
        setTotal(1);
      }
    
  }

//===Event handler end here===

return { handleGetRelativesData , searchResult , currentPage , totalPages , total, loading , error };

}

